// src/pages/TourStatements/TourStatementsCompanySelection.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import companyService from '../../services/company.service';
import Toast from '../../components/Toast/Toast';
import './TourStatements.css';

const TourStatementsCompanySelection = () => {
  const navigate = useNavigate();
  const { isSuperAdmin, user } = useAuth();

  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    if (!isSuperAdmin) {
      const companyId = user?.companyId;
      if (companyId) {
        navigate(`/orders/tour-statements/employees/${companyId}`, {
          replace: true,
          state: { companyName: user?.company?.name }
        });
      } else {
        setToast({ message: 'Company not assigned to your account', type: 'error' });
      }
      return;
    }
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const response = await companyService.getAllCompanies();

      if (response.success && response.data) {
        setCompanies(response.data);
      }
    } catch (error) {
      console.error('Error fetching companies:', error);
      setToast({ message: 'Failed to fetch companies', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleViewEmployeeList = (company) => {
    navigate(`/orders/tour-statements/employees/${company.id}`, {
      state: { companyName: company.name }
    });
  };

  return (
    <div className="tour-statements-page">
      {/* Toast Notification */}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}

      {/* Header */}
      <div className="tour-header">
        <h4 className="tour-title">Tour Statements</h4>
      </div>

      {/* Company Selection */}
      <div className="company-selection-section">
        <h5 className="section-subtitle">Select Company</h5>

        <div className="companies-table-container">
          {loading ? (
            <div className="loading">Loading companies...</div>
          ) : (
            <table className="companies-table">
              <thead>
                <tr>
                  <th>COMPANY NAME</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {companies.length > 0 ? (
                  companies.map((company) => (
                    <tr key={company.id}>
                      <td>{company.name}</td>
                      <td>
                        <button
                          className="btn-view-employees"
                          onClick={() => handleViewEmployeeList(company)}
                        >
                          View Employee List
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="no-data">
                      No companies available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default TourStatementsCompanySelection;